export default "__VITE_ASSET__e2c2bba0__"